import React from "react";

const Contract = () => {
  return (
    <div id="contract">
      <h1 className="text-xl font-bold text-center title">About Me</h1>
      <h2 className="text-4xl font-bold text-center text-white">
        A Passionate Developer Who
        <br /> Loves to Code
      </h2>
      <section class="">
        <div class="container px-2 py-5 mx-auto">
          <div class="mt-8 lg:flex lg:items-center justify-around gap-32 mx-4">
            <div  data-aos="fade-right"
              data-aos-duration="2000">
              <div className="flex" bis_skin_checked="1">
                <div className="flex-shrink-0" bis_skin_checked="1">
                  <div
                    className="flex items-center justify-center"
                    bis_skin_checked="1"
                  >
                    <a
                      href="#!"
                      type="button"
                      class="rounded-full text-white leading-normal uppercase bg-sky-500 hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-20 h-20"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-10 mx-auto h-full"
                      >
                        <title>ionicons-v5-n</title>
                        <path
                          d="M256,32C167.67,32,96,96.51,96,176c0,128,160,304,160,304S416,304,416,176C416,96.51,344.33,32,256,32Zm0,224a64,64,0,1,1,64-64A64.07,64.07,0,0,1,256,256Z"
                          fill="white"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="ml-6 mt-1" bis_skin_checked="1">
                  <h4 className="text-3xl font-bold leading-6 dark:text-gray-50">
                    Location
                  </h4>
                  <p className="mt-4 -mx-3 text-gray-400 text-md font-normal">
                    152/1,Bilashdi,Narsingdi <br/>Dhaka,Bangladesh.
                  </p>
                </div>
              </div>
              <div className="flex mt-10" bis_skin_checked="1">
                <div className="flex-shrink-0" bis_skin_checked="1">
                  <div
                    className="flex items-center justify-center"
                    bis_skin_checked="1"
                  >
                    <a
                      href="#!"
                      type="button"
                      class="rounded-full text-white leading-normal uppercase bg-sky-500 hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-20 h-20"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-10 mx-auto h-full"
                      >
                        <title>ionicons-v5-n</title>
                        <path
                          d="M256,32C167.67,32,96,96.51,96,176c0,128,160,304,160,304S416,304,416,176C416,96.51,344.33,32,256,32Zm0,224a64,64,0,1,1,64-64A64.07,64.07,0,0,1,256,256Z"
                          fill="white"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="ml-6 mt-1" bis_skin_checked="1">
                  <h4 className="text-3xl font-bold leading-6 dark:text-gray-50">
                    Phone
                  </h4>
                  <p className="mt-4 text-gray-400 text-md font-normal">
                    +880 1683338523
                  </p>
                </div>
              </div>
              <div className="flex mt-10" bis_skin_checked="1">
                <div className="flex-shrink-0" bis_skin_checked="1">
                  <div
                    className="flex items-center justify-center"
                    bis_skin_checked="1"
                  >
                    <a
                      href="#!"
                      type="button"
                      class="rounded-full text-white leading-normal uppercase bg-sky-500 hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out w-20 h-20"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-10 mx-auto h-full"
                      >
                        <title>ionicons-v5-n</title>
                        <path
                          d="M256,32C167.67,32,96,96.51,96,176c0,128,160,304,160,304S416,304,416,176C416,96.51,344.33,32,256,32Zm0,224a64,64,0,1,1,64-64A64.07,64.07,0,0,1,256,256Z"
                          fill="white"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="ml-6 mt-1" bis_skin_checked="1">
                  <h4 className="text-3xl font-bold leading-6 dark:text-gray-50">
                    Email
                  </h4>
                  <p className="mt-4 text-gray-400 text-md font-normal">
                    aurthohinparvez2@gmail.com
                  </p>
                </div>
              </div>
            </div>

            <div
              class="mt-6 lg:w-1/2 lg:mt-0 lg:mx-8 "
              alt=""
              data-aos="fade-left"
              data-aos-duration="2000"
            >
              <div
                className="grid grid-cols-6 gap-6 col-span-full lg:col-span-2"
                bis_skin_checked="1"
              >
                <div
                  className="col-span-full sm:col-span-3"
                  bis_skin_checked="1"
                >
                  <input
                        id="username"
                        type="text"
                        placeholder="Your Name"
                        class=" block w-60 h-14 px-2 mt-2 text-gray-700 input border border-gray-400 rounded-lg focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring"
                      />
                </div>
                <div
                  className="col-span-full sm:col-span-3"
                  bis_skin_checked="1"
                >
                  <input
                        id="username"
                        type="text"
                        placeholder="Your Email"
                        class="block w-60 h-14 px-4 mt-2 text-gray-700 input border border-gray-400 rounded-lg focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring"
                      />
                </div>
                <div
                  className="col-span-full sm:col-span-3"
                  bis_skin_checked="1"
                >
                  <input
                        id="username"
                        type="text"
                        placeholder="Your Phone"
                        class="block w-60 h-14 px-2 mt-2 text-gray-700 input border border-gray-400 rounded-lg focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring"
                      />
                </div>
                <div
                  className="col-span-full sm:col-span-3"
                  bis_skin_checked="1"
                >
                  <input
                        id="username"
                        type="text"
                        placeholder="Subject"
                        class="block w-60 h-14 px-4 mt-2 text-gray-700 input border border-gray-400 rounded-lg focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring"
                      />
                </div>
                <div className="col-span-full" bis_skin_checked="1">
                  <textarea
                    id="bio"
                    placeholder="Write Your Message Here"
                    className="w-full h-48 input rounded-lg focus:ring focus:ring-opacity-75 focus:ring-violet-400 border border-gray-400"
                  ></textarea>
                </div>
                
              </div>
              <button type="button" className="px-8 w-48 mt-10 py-4 font-semibold rounded-full bg-sky-400 hover:bg-teal-600 text-white text-lg">Submit Now</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contract;
